export default __webpack_public_path__ + "static/media/P20-Tip-Solution.0a956515.svg";